import { Container, Paper, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { ApplicantWorkbook } from './ApplicantWorkbook'

export const ApplicantApplication = () => {
    const leasingContext = useSelector(
        (state: RootState) => state.user.leasingContext,
    )

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper
                sx={{
                    p: 4,
                    backgroundColor: '#2a2f35',
                    border: '1px solid',
                    borderColor: 'grey.700',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
                }}
            >
                <Typography
                    variant="h4"
                    gutterBottom
                    sx={{ fontWeight: 600, color: '#fff' }}
                >
                    Your Application
                </Typography>
                {leasingContext?.apartment && (
                    <Typography variant="body1" sx={{ color: '#8b949e', mb: 3 }}>
                        {leasingContext.apartment.name}
                    </Typography>
                )}

                {leasingContext?.active_lead_id ? (
                    <ApplicantWorkbook leadId={leasingContext.active_lead_id} />
                ) : (
                    <Typography sx={{ color: '#8b949e' }}>
                        No active application was found for your account.
                    </Typography>
                )}
            </Paper>
        </Container>
    )
}
